<template>
  <div class="home">
    <app-header ></app-header>
    <app-hiraya-message></app-hiraya-message>
    <app-factory-message></app-factory-message>
    <app-awards></app-awards>
    <app-footer></app-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderCustom from "@/components/home/HeaderCustom.vue";
import HirayaMessage from "@/components/home/HirayaMessage.vue";
import FactoryMessage from "@/components/home/FactoryMessage.vue";
import AwardsAndRecognitions from "@/components/home/AwardsAndRecognitions.vue";
import Footer from "@/components/general/Footer.vue";


export default {
name: "home",
components: {
  'app-header': HeaderCustom,
  'app-hiraya-message': HirayaMessage,
  'app-factory-message': FactoryMessage,
  'app-awards' : AwardsAndRecognitions,
  'app-footer' : Footer,
  }
}   

</script>

